import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { formatCurrency } from '../../lib/formatters';

const SortableHeader = ({ children, column, currentSort, onSort, className = '' }) => (
  <TableHead
    className={`cursor-pointer hover:bg-blue-200 text-right ${className}`}
    onClick={() => onSort(column)}
  >
    {children} {currentSort.column === column && (currentSort.direction === 'asc' ? '↑' : '↓')}
  </TableHead>
);

const DealsTable = ({
  deals,
  totals,
  sortConfig,
  onSort,
  withdrawalAmounts,
  onWithdrawalAmountChange,
  onWithdraw
}) => {
  return (
    <div className="space-y-4">
      {/* Totals Row */}
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-100">
            <TableHead className="font-bold">Totals</TableHead>
            <TableHead className="font-bold text-right">Advance Amount</TableHead>
            <TableHead className="font-bold text-right">Target Collection</TableHead>
            <TableHead className="font-bold text-right">Running Collection</TableHead>
            <TableHead className="font-bold text-right">Withdrawals</TableHead>
            <TableHead className="font-bold text-right">Balance</TableHead>
            <TableHead className="font-bold text-right">Withdrawal Amount</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow className="bg-gray-50 font-semibold">
            <TableCell></TableCell>
            <TableCell className="text-right">{formatCurrency(totals.advanceAmount)}</TableCell>
            <TableCell className="text-right">{formatCurrency(totals.targetCollection)}</TableCell>
            <TableCell className="text-right">{formatCurrency(totals.runningCollection)}</TableCell>
            <TableCell className="text-right">{formatCurrency(totals.withdrawals)}</TableCell>
            <TableCell className="text-right">{formatCurrency(totals.balance)}</TableCell>
            <TableCell className="text-right">{formatCurrency(totals.withdrawalAmount)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* Deals Table */}
      <div className="overflow-x-auto border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow className="bg-blue-100">
              <SortableHeader column="merchant_shortcode" currentSort={sortConfig} onSort={onSort} className="text-left">
                Merchant
              </SortableHeader>
              <SortableHeader column="deal_name" currentSort={sortConfig} onSort={onSort} className="text-left">
                Deal Name
              </SortableHeader>
              <SortableHeader column="funded_date" currentSort={sortConfig} onSort={onSort} className="text-left">
                Funded Date
              </SortableHeader>
              <SortableHeader column="advance_amount" currentSort={sortConfig} onSort={onSort}>
                Advance Amount
              </SortableHeader>
              <SortableHeader column="target_collection" currentSort={sortConfig} onSort={onSort}>
                Target Collection
              </SortableHeader>
              <SortableHeader column="running_collection" currentSort={sortConfig} onSort={onSort}>
                Running Collection
              </SortableHeader>
              <SortableHeader column="withdrawals" currentSort={sortConfig} onSort={onSort}>
                Total Withdrawals
              </SortableHeader>
              <SortableHeader column="balance" currentSort={sortConfig} onSort={onSort}>
                Balance
              </SortableHeader>
              <TableHead className="text-center">Withdraw Amt</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {deals.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} className="text-center py-8 text-gray-500">
                  No syndicated deals found.
                </TableCell>
              </TableRow>
            ) : (
              deals.map((deal) => (
                <TableRow key={deal.deal_id} className="hover:bg-gray-50">
                  <TableCell className="text-blue-600 font-medium">
                    {deal.merchant_shortcode || (deal.deal_name ? deal.deal_name.substring(0, 4).toUpperCase() : '-')}
                  </TableCell>
                  <TableCell className="text-blue-600">{deal.deal_name || '-'}</TableCell>
                  <TableCell>{deal.funded_date || '-'}</TableCell>
                  <TableCell className="text-right">{formatCurrency(deal.advance_amount)}</TableCell>
                  <TableCell className="text-right">{formatCurrency(deal.target_collection)}</TableCell>
                  <TableCell className={`text-right ${deal.running_collection < 0 ? 'text-red-600' : ''}`}>
                    {formatCurrency(deal.running_collection)}
                  </TableCell>
                  <TableCell className="text-right">{formatCurrency(deal.withdrawals)}</TableCell>
                  <TableCell className="text-right font-semibold">
                    {formatCurrency(deal.balance)}
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center space-x-2">
                      <Input
                        type="number"
                        step="0.01"
                        min="0"
                        max={deal.balance}
                        value={withdrawalAmounts[deal.deal_id] || ''}
                        onChange={(e) => onWithdrawalAmountChange(deal.deal_id, e.target.value)}
                        className="w-28"
                        placeholder="0.00"
                      />
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => onWithdraw(deal.deal_id)}
                        disabled={!withdrawalAmounts[deal.deal_id] || parseFloat(withdrawalAmounts[deal.deal_id]) <= 0}
                      >
                        Withdraw
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default DealsTable;
